module.exports = __webpack_public_path__ + "img/Logos_TXT.0af6edb1.svg";